import { render, staticRenderFns } from "./realTimeorder.vue?vue&type=template&id=8a60b24e&scoped=true&"
import script from "./realTimeorder.vue?vue&type=script&lang=js&"
export * from "./realTimeorder.vue?vue&type=script&lang=js&"
import style0 from "./realTimeorder.vue?vue&type=style&index=0&id=8a60b24e&prod&lang=less&"
import style1 from "./realTimeorder.vue?vue&type=style&index=1&id=8a60b24e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a60b24e",
  null
  
)

export default component.exports